import React from 'react';
import {Pane, PaneProps} from 'evergreen-ui';
// import SoftReleaseStatusSelect from '../SoftReleaseStatusSelect';
import {useSelectedEnabledModeMonitoring} from "../../Hooks/useSelectedEnabledModeMonitoring";
import {useSelectedDangerModeMonitoring} from "../../Hooks/useSelectedDangerModeMonitoring";
import {useSelectedDataReceivedMonitoring} from "../../Hooks/useSelectedDataRecievedMonitoring";
import {useSelectedStormModeMonitoring} from "../../Hooks/useSelectedStormModeMonitoring";
import DangerModeStatusSelectMonitoring from "../../Selectors/DangerModeStatusSelectMonitoring";
import DataReceivedStatusSelectMonitoring from "../../Selectors/DataRecievedStatusSelectMonitoring";
import StormModeStatusSelectMonitoring from "../../Selectors/StormModeStatusSelectMonitoring";
import EnableModeStatusSelectMonitoring from "../../Selectors/EnableModeStatusSelectMonitoring";

export function DatasourcesFilterByStatusesMonitoring(props: PaneProps) {
    const { enableMode, onSelectEnableMode } = useSelectedEnabledModeMonitoring();
    const { dangerMode, onSelectDangerMode } = useSelectedDangerModeMonitoring();
    // const { softRelease, onSelectSoftRelease } = useSelectedSoftRelease();
    const { dataReceived, onSelectDataReceived } = useSelectedDataReceivedMonitoring();
    const { stormMode, onSelectStormMode } = useSelectedStormModeMonitoring();

    return (
        <Pane display="flex" gap=".2rem" {...props}>
            <EnableModeStatusSelectMonitoring selected={enableMode} onSelect={onSelectEnableMode} />
            <DangerModeStatusSelectMonitoring selected={dangerMode} onSelect={onSelectDangerMode} />
            <DataReceivedStatusSelectMonitoring selected={dataReceived} onSelect={onSelectDataReceived} />
            <StormModeStatusSelectMonitoring selected={stormMode} onSelect={onSelectStormMode} />
            {/* <SoftReleaseStatusSelect selected={softRelease} onSelect={onSelectSoftRelease} /> */}
        </Pane>
    );
}
